// extracted by mini-css-extract-plugin
module.exports = {"main":"SettingsPage_main__cB1ja"};